// routes
import { PATH_DASHBOARD } from "../../../routes/paths";

// components
import SvgIconStyle from "../../../components/SvgIconStyle";

import { Shop } from "redux/slices/auth";
import { company } from "apis";
import { PATH_LEVEL } from "utils/dataCenter";

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: "100%", height: "100%" }}
  />
);

const ICONS = {
  cart: getIcon("ic_cart"),
  setting: getIcon("ic_setting"),
  home: getIcon("ic_home"),
  trendingup: getIcon("ic_trendingup"),
  description: getIcon("ic_descript"),
  appinfo: getIcon("ic_appInfo"),
};

export const getSidebarConfig = (shop: Shop) => {
  const sidebarConfig: any = [
    {
      subheader: "매출 관리",
      items: [
        {
          title: "매출 관리",
          path: PATH_DASHBOARD.sales.root,
          icon: ICONS.trendingup,
          children: [
            { title: "매출 분석", path: PATH_DASHBOARD.sales.salesanaly },
            { title: "메뉴별 판매량", path: PATH_DASHBOARD.sales.salesbymenu },
          ],
        },
      ],
    },
  ];

  const { SHOP_AUTH } = shop;

  let PLUG_IN_NB = false;
  let PLUG_IN_MA = false;

  if (shop.PLUG_IN_NB) {
    PLUG_IN_NB = true;
  }

  if (shop.PLUG_IN_MA) {
    PLUG_IN_MA = true;
  }

  switch (SHOP_AUTH?.toString()) {
    case PATH_LEVEL.BASIC:
      sidebarConfig.push({
        subheader: "발주 관리",
        items: [
          {
            title: "발주 관리",
            path: PATH_DASHBOARD.home.root,
            icon: ICONS.cart,
            children: [
              // {
              //   title: "발주량 자동산출",
              //   path: PATH_DASHBOARD.home.AutomaticCalculation,
              // },
              { title: "발주 분석", path: PATH_DASHBOARD.home.OrderAnalysis },
              // {
              //   title: "발주량 분석", path: PATH_DASHBOARD.home.quantity,
              // },
              { title: "정량 조리율", path: PATH_DASHBOARD.home.cookingrate },
            ],
          },
        ],
      });
      break;
    case PATH_LEVEL.STANDARD:
      sidebarConfig.push(
        {
          subheader: "발주 관리",
          items: [
            {
              title: "발주 관리",
              path: PATH_DASHBOARD.home.root,
              icon: ICONS.cart,
              children: [
                // {
                //   title: "발주량 자동산출",
                //   path: PATH_DASHBOARD.home.AutomaticCalculation,
                // },
                { title: "발주 분석", path: PATH_DASHBOARD.home.OrderAnalysis },
                // {
                //   title: "발주량 분석", path: PATH_DASHBOARD.home.quantity,
                // },
                { title: "정량 조리율", path: PATH_DASHBOARD.home.cookingrate },
              ],
            },
          ],
        },
        {
          subheader: "재고 관리",
          items: [
            {
              title: "재고 관리",
              path: PATH_DASHBOARD.inventory.inventory,
              icon: ICONS.description,
            },
          ],
        }
      );
      break;
    case PATH_LEVEL.PREMIUM: {
      sidebarConfig.push(
        {
          subheader: "발주 관리",
          items: [
            {
              title: "발주 관리",
              path: PATH_DASHBOARD.home.root,
              icon: ICONS.cart,
              children: [
                // {
                //   title: "발주량 자동산출",
                //   path: PATH_DASHBOARD.home.AutomaticCalculation,
                // },
                { title: "발주 분석", path: PATH_DASHBOARD.home.OrderAnalysis },
                // {
                //   title: "발주량 분석", path: PATH_DASHBOARD.home.quantity,
                // },
                { title: "정량 조리율", path: PATH_DASHBOARD.home.cookingrate },
              ],
            },
          ],
        },
        {
          subheader: "재고 관리",
          items: [
            {
              title: "재고 관리",
              path: PATH_DASHBOARD.inventory.inventory,
              icon: ICONS.description,
            },
          ],
        }
      );
      break;
    }
    default: {
      break;
    }
  }

  if (PLUG_IN_MA) {
    sidebarConfig[0].items[0].children.push({
      title: "지역 분석",
      path: PATH_DASHBOARD.sales.mapanalytics,
    });
  }

  if (PLUG_IN_NB) {
    sidebarConfig.splice(0, 0, {
      subheader: "게시판",
      items: [
        {
          title: "게시판",
          path: PATH_DASHBOARD.board.root,
          icon: ICONS.description,
          children: [{ title: "공지사항", path: PATH_DASHBOARD.board.notice }],
        },
      ],
    });
  }

  return sidebarConfig;
};
